import { get } from 'lodash';
import { Modals, Pages, Templates } from '../helpers/Constants';

const base = 'ProductionReportState.reports';

export const getData = state => get(state, `${base}.productionReportSetup.Data`);
export const getError = state => get(state, `${base}.fetchError`);
export const getShowCreateNewReportModal = (state) => get(state, `${base}.${Modals.CreateNewReport}`, false);
export const getPage = (state) => get(state, `${base}.page`, Pages.SelectTemplate);
export const getTemplate = (state) => get(state, `${base}.template`, Templates.Simple);
export const getMealTypes = (state) => get(state, `${base}.mealTypes`, []);
export const getDetails = (state) => get(state, `${base}.details`, '');
export const getOtherDetails = (state) => get(state, `${base}.otherDetails`, '');
export const getReportNotes = (state) => get(state, `${base}.reportNotes`, '');


// WEBPACK FOOTER //
// ./src/pages/productionreportsetup/state/selectors.js